// Shared controls. Shopify owns contact delivery and localization; the local
// renderer marks its isolated forms explicitly and never forwards their input.
const disclosures=[...document.querySelectorAll('.header-disclosure')];
disclosures.forEach(details=>{
 details.addEventListener('toggle',()=>{if(details.open){disclosures.forEach(other=>{if(other!==details)other.open=false});if(details.classList.contains('search-disclosure'))details.querySelector('input[type="search"]')?.focus();}});
 details.addEventListener('keydown',event=>{if(event.key==='Escape'){details.open=false;details.querySelector('summary')?.focus();}});
 if(details.classList.contains('search-disclosure'))details.addEventListener('focusout',event=>{
  if(!details.contains(event.relatedTarget))details.open=false;
 });
});
document.addEventListener('click',event=>disclosures.forEach(details=>{if(details.open&&!details.contains(event.target))details.open=false;}));
document.querySelector('[data-local-withdrawal]')?.addEventListener('submit',event=>{
 event.preventDefault();const form=event.currentTarget;if(!form.reportValidity())return;
 const feedback=form.querySelector('[data-withdrawal-error]');feedback.hidden=false;feedback.focus();
});
document.querySelector('[data-local-localization]')?.addEventListener('submit',event=>{
 event.preventDefault();const form=event.currentTarget;form.reset();form.querySelector('[data-localization-error]').hidden=false;
});
document.querySelectorAll('.search-form').forEach(form=>form.addEventListener('submit',event=>{
 const query=form.querySelector('[name="q"]');query.value=query.value.trim();if(!query.value){event.preventDefault();query.reportValidity();}
}));
